function country(name, code, image) {
  return { name, code, image };
}

const countries = [
  country("South Korea (KR)", "KR", "https://flagcdn.com/w40/kr.png"),
  country("Albania (AL)", "AL", "https://flagcdn.com/w40/al.png"),
  country("Australia (AU)", "AU", "https://flagcdn.com/w40/au.png"),
  country("Azerbaijan (AZ)", "AZ", "https://flagcdn.com/w40/az.png"),
  country("Belarus (BY)", "BY", "https://flagcdn.com/w40/by.png"),
  country("Bolivia (BO)", "BO", "https://flagcdn.com/w40/bo.png"),
  country("Bosnia (BA)", "BA", "https://flagcdn.com/w40/ba.png"),
  country("Bulgaria (BG)", "BG", "https://flagcdn.com/w40/bg.png"),
  country("Canada (CA)", "CA", "https://flagcdn.com/w40/ca.png"),
  country("China (CN)", "CN", "https://flagcdn.com/w40/cn.png"),
  country("Chinese Taipei (TW)", "TW", "https://flagcdn.com/w40/tw.png"),
  country("Finland (FI)", "FI", "https://flagcdn.com/w40/fi.png"),
  country("Greece (GR)", "GR", "https://flagcdn.com/w40/gr.png"),
  country("Hong Kong (HK)", "HK", "https://flagcdn.com/w40/hk.png"),
  country("Hungary (HU)", "HU", "https://flagcdn.com/w40/hu.png"),
  country("India (IN)", "IN", "https://flagcdn.com/w40/in.png"),
  country("Indonesia (ID)", "ID", "https://flagcdn.com/w40/id.png"),
  country("Iran (IR)", "IR", "https://flagcdn.com/w40/ir.png"),
  country("Jordan (JO)", "JO", "https://flagcdn.com/w40/jo.png"),
  country("Kazakhstan (KZ)", "KZ", "https://flagcdn.com/w40/kz.png"),
  country("Kyrgyzstan (KG)", "KG", "https://flagcdn.com/w40/kg.png"),
  country("Lebanon (LB)", "LB", "https://flagcdn.com/w40/lb.png"),
  country("Moldova (MD)", "MD", "https://flagcdn.com/w40/md.png"),
  country("Mongolia (MN)", "MN", "https://flagcdn.com/w40/mn.png"),
  country("Montenegro (ME)", "ME", "https://flagcdn.com/w40/me.png"),
  country("North Macedonia (MK)", "MK", "https://flagcdn.com/w40/mk.png"),
  country("Norway (NO)", "NO", "https://flagcdn.com/w40/no.png"),
  country("Pakistan (PK)", "PK", "https://flagcdn.com/w40/pk.png"),
  country("Peru (PE)", "PE", "https://flagcdn.com/w40/pe.png"),
  country("Poland (PL)", "PL", "https://flagcdn.com/w40/pl.png"),
  country("Romania (RO)", "RO", "https://flagcdn.com/w40/ro.png"),
  country("Russia (RU)", "RU", "https://flagcdn.com/w40/ru.png"),
  country("Serbia (RS)", "RS", "https://flagcdn.com/w40/rs.png"),
  country("Singapore (SG)", "SG", "https://flagcdn.com/w40/sg.png"),
  country("Slovakia (SK)", "SK", "https://flagcdn.com/w40/sk.png"),
  country("South Africa (ZA)", "ZA", "https://flagcdn.com/w40/za.png"),
  country("Thailand (TH)", "TH", "https://flagcdn.com/w40/th.png"),
  country("Turkmenistan (TM)", "TM", "https://flagcdn.com/w40/tm.png"),
  country("Türkiye (TR)", "TR", "https://flagcdn.com/w40/tr.png"),
  country("Uzbekistan (UZ)", "UZ", "https://flagcdn.com/w40/uz.png"),
  country("Vietnam (VN)", "VN", "https://flagcdn.com/w40/vn.png"),
  country("Malaysia (MY)", "MY", "https://flagcdn.com/w40/my.png"),
  country("Northern Cyprus (NC)", "NC", "https://flagcdn.com/w40/nc.png"),
];

export const findCountryFlag = (countryCode) => {
  var code = countryCode === "CHN" ? "CN" : countryCode;

  for (var i in countries) {
    if (countries[i].code === code) {
      return countries[i].image;
    }
  }
}